module.exports = __webpack_public_path__ + "static/media/BobabarUIFrames.7c9f8b5e.jpg";